import { render, staticRenderFns } from "./admin-widget-analytics.vue?vue&type=template&id=8e7e4c38&scoped=true&"
import script from "./admin-widget-analytics.vue?vue&type=script&lang=js&"
export * from "./admin-widget-analytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7e4c38",
  null
  
)

export default component.exports